// Lightweight client for the admin API + token storage in localStorage.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "zw_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export async function login(username, password) {
  const { data } = await axios.post(`${API}/admin/login`, { username, password });
  setToken(data.token);
  return data;
}

export async function me() {
  const { data } = await axios.get(`${API}/admin/me`, { headers: authHeader() });
  return data;
}

export async function listLeads() {
  const { data } = await axios.get(`${API}/leads`, { headers: authHeader() });
  return data;
}

export async function deleteLead(id) {
  await axios.delete(`${API}/leads/${id}`, { headers: authHeader() });
}

export async function listReviews() {
  const { data } = await axios.get(`${API}/reviews`, { headers: authHeader() });
  return data;
}

export async function approveReview(id, approved) {
  const { data } = await axios.patch(
    `${API}/reviews/${id}/approve?approved=${approved}`,
    null,
    { headers: authHeader() }
  );
  return data;
}

export async function deleteReview(id) {
  await axios.delete(`${API}/reviews/${id}`, { headers: authHeader() });
}

export function logout() {
  clearToken();
}
